export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/facebook.985bf474.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};